import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-time-range-config-view',
  standalone: true,
  templateUrl: './time-range-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeRangeConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
